import * as React from 'react';
import DatePicker from 'react-date-picker';
import { IconCalendar } from '../../Icons';
import { EInputTextType } from '../index';

import '../../../styles/InputDate.scss'; // Import css modules stylesheet as styles

interface IProps {
  name?: string;
  minDate?: Date;
  maxDate?: Date;
  value?: Date | null | undefined | [Date | null, Date | null];
  onChange?: (name: string, value: Date | Date[]) => void;
  additionalClass?: string;
  isDisabled?: boolean;
  inputTextType?: EInputTextType;
  autoFocus?: boolean;
  readOnly?: boolean;
  maxLength?: number;
}

interface IState {}

export class InputDate extends React.Component<IProps, IState> {
  public render() {
    const { name, value, onChange, minDate, maxDate } = this.props;

    return (
      <DatePicker
        minDate={minDate}
        maxDate={maxDate}
        name={name}
        className={'inputDate'}
        calendarIcon={<IconCalendar />}
        clearIcon={null}
        value={value}
        onChange={(date) => onChange(name, date)}
      />
    );
  }
}
